<template>
  <div class="day_view">
    <div class="date_body">
      <div class="scroll_content_day">
        <div class="scroll_content_day_box">
          <div class="date_body_scale">
            <div class="scale_item" v-for="(item,index) in 24">
              {{ item | formatScale }}
            </div>
          </div>
          <div class="date_body_content">
            <div class="day_list">
              <div class="hours_list" v-for="(itemHours,indexH) in 24">
                <TaskDefaultPop v-if="formatTaskList[todayDate + ':' + (indexH<10?'0'+indexH:indexH)] != undefined"
                                :taskList="formatTaskList[todayDate + ':' + (indexH<10?'0'+indexH:indexH)]" :invoke="invoke"></TaskDefaultPop>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {utils} from '../common/common'
import TaskDefaultPop from './TaskDefaultPop.vue'

export default {
  components: {
    TaskDefaultPop
  },
  props: {
    dateValue: String,
    invoke:Function,
    dayData:Array,
    currentDateType:String
  },
  watch: {
    dateValue: function (val) {
      this.todayDate = utils.dateFormat("yyyy/MM/dd", this.dateValue)
      if(this.currentDateType === 'date'){
        this.getDayData(val);
      }
    },
    currentDateType:function (val){
      if(val === 'date'){
        this.getDayData(this.dateValue);
      }
    },
    dayData(val){
      this.formatTaskList = this.formatTask(val)
    }
  },
  filters: {
    clearYear(time) {
      if (time != undefined || time != null) {
        return String(time).substring(5);
      } else {
        return ''
      }
    },
    formatScale(num) {
      num = num - 1;
      if (num < 10) {
        num = "0" + num;
      }
      return num + ":00";

    }
  },
  data() {
    return {
      todayDate: [],
      formatTaskList: []
    }
  },
  mounted() {

    this.$nextTick(()=>{
      //去除滚动条
      this.clearScroll();
      this.initTimePosition();
    })

  },
  methods: {
    clearScroll() {
      let scrollWidth = $(".day_view .scroll_content_day")[0].offsetWidth - $(".day_view .scroll_content_day")[0].clientWidth;
      $(".day_view .scroll_content_day").css("marginRight", "-" + scrollWidth + "px")
    },
    formatTask(list) {
      let newTaskObj = {};
      for (let i = 0; i < list.length; i++) {
        if (list[i].startTimeLong == "" || list[i].startTimeLong == null || list[i].startTimeLong == undefined) {
          continue;
        }
        let timeStr = utils.dateFormat("yyyy/MM/dd:hh", list[i].startTimeLong);
        if (!newTaskObj[timeStr]) {
          newTaskObj[timeStr] = [];
        }
        newTaskObj[timeStr].push(list[i])
      }
      return newTaskObj;
    },
    initTimePosition() {
      let curHourse = new Date().getHours();
      if (curHourse < 13) {
        $(".day_view .scroll_content_day").animate({scrollTop: "335px"}, 500);
      } else {
        $(".day_view .scroll_content_day").animate({scrollTop: "505px"}, 500);
      }
    },
    getDayData(val){
      let timeRange = {
        startTime:this.getZeroTime(val),
        endTime:this.getZeroTime(utils.getNextDate(val,1))
      }
      console.log('获取天数据',val)
      console.log(new Date(timeRange.startTime),new Date(timeRange.endTime))
      this.invoke('getDayData', timeRange);
    }
  }
}
</script>
<style lang="less">
.day_view {
  color: #333333;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  flex-grow: 1;
  flex-shrink: 1;
  height: 100px;

  .date_body {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    flex-grow: 1;
    flex-shrink: 1;
    height: 100px;
    overflow-x: hidden;

    .scroll_content_day {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      flex-grow: 1;
      flex-shrink: 1;
      overflow-y: scroll;
      .scroll_content_day_box{
        display: flex;
        flex-direction: row;
        flex-grow: 0;
        flex-shrink: 0;
      }
    }

    .date_body_scale {
      width: 55px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      align-items: stretch;

      .scale_item {
        flex-shrink: 0;
        height: 42px;
        text-align: center;
      }
    }

    .date_body_content {
      display: flex;
      flex-direction: row;
      flex-grow: 1;
      flex-shrink: 1;
      border: 1px solid #E5E5E5;
      border-bottom: 0;

      .day_list {
        width: 100px;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;

        .hours_list {
          display: flex;
          flex-direction: row;
          align-items: stretch;
          flex-shrink: 0;
          height: 42px;
          border-bottom: 1px solid #E5E5E5;
          //&:hover{
          //  background: #EDF2FF;
          //}

        }
      }
    }
  }
}

</style>